
import { get, post } from './ApiService'

import config from '../config'

export const loadProgrammation = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}`

  return await get(url, 'GET_PROGRAMMATION')
}

export const loadTasklist = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}/tasklist`

  return await get(url, 'GET_PROGRAMMATION_TASKLIST')
}

export const loadTasks = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}/tasks`

  return await get(url, 'GET_PROGRAMMATION_TASKS')
}

export const loadUsers = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}/users`

  const data = {}

  return await post(url, data, 'GET_PROGRAMMATION_USERS')
}

export const loadColorCodes = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}/colorcodes`

  return await get(url, 'GET_PROGRAMMATION_COLORCODES')
}

export const loadRelations = async (project_id: string, tasks_ids: string[]) => {

  const url = `${config.apiHost}/programmation/${project_id}/relations`

  const data = {
    tasks_ids
  }

  return await post(url, data, 'GET_PROGRAMMATION_RELATIONS')
}

export const loadVersions = async (project_id: string, tasks_ids: string[]) => {

  const url = `${config.apiHost}/programmation/${project_id}/versions`

  const data = {
    tasks_ids
  }

  return await post(url, data, 'GET_PROGRAMMATION_VERSIONS')
}

export const loadDocuments = async (project_id: string) => {

  const url = `${config.apiHost}/programmation/${project_id}/documents`

  return await post(url, { project_id }, 'GET_PROGRAMMATION_DOCUMENTS')
}

const encodeBase64Unicode = (str: string) => {
  const utf8Bytes = new TextEncoder().encode(str); // returns Uint8Array
  const binary = Array.from(utf8Bytes).map(b => String.fromCharCode(b)).join('');
  return btoa(binary);
}

export const exportToPdf = async (plan: string, data: any) => {

  const url = `${config.apiHost}/export/pdf/${plan}`

  const body = {
    data: encodeBase64Unicode(JSON.stringify(data))
  }

  return await post(url, body, 'EXPORT_TO_PDF')
}
